<template>
  <span>{{ time | time(format) }}</span>
</template>

<script>
  import { DateTime } from 'luxon';
  export default {
    props: ['time', 'format'],
  };
</script>